export default [
    {
        name: "MeasureUnitCreate",
        path: "measure-unit",
        component: () => import('./../../views/warehouse/MeasureUnitCreateView.vue')
    },
    {
        name: "MeasureUnitDisplay",
        path: "measure-unit/:id",
        component: () => import('./../../views/warehouse/MeasureUnitDisplayView.vue')
    },
    {
        name: "MeasureUnitEdit",
        path: "measure-unit/:id/edit",
        component: () => import('./../../views/warehouse/MeasureUnitEditView.vue')
    },
    {
        name: "MeasureUnitList",
        path: "measure-units",
        component: () => import('./../../views/warehouse/MeasureUnitListView.vue')
    }
]